<template>
    <div v-if="cartProduct" class="cart-list--item">
        <div class="cart-list--item--col">
            <a :href="product.url">
                <ProductImage :product="product" :variant="product.product_variant" singleClass="product-image-cart" bundleClass="cart-bundle-image" />
            </a>
        </div>

        <div class="cart-list--item--col">
            <div class="short-product-info short-product-info-medium">
                <a :href="product.url">
                    <h2>
                        <span v-if="data.product_state_title" class="flag" :class="data.product_state_flag">
                            {{ data.product_state_title }}:
                        </span>

                        {{ cartProduct.product_variant ? cartProduct.product_variant.title : product.title }}
                    </h2>
                </a>

                <h4>
                    <span v-for="author in data.authors" :key="author.id">
                        <a :href="author.url">{{ author.name }}</a>
                    </span>
                </h4>
            </div>
        </div>

        <div class="cart-list--item--col col-flex">
            <div class="quantity">
                <div class="quantity--btn btn-minus" :class="{ 'btn-disabled': quantity === 1 }"  @click="updateQuantity('-')"></div>

                <div class="quantity--input">
                    <input type="number" v-model="quantity" readonly>
                </div>

                <div class="quantity--btn btn-plus" :class="{ 'btn-disabled': !cartProduct.can_be_added }"  @click="updateQuantity('+')"></div>
            </div>
        </div>

        <div class="cart-list--item--col col-price">
            {{ cartProduct.product_price_with_tax_final_sum_formatted }}
        ​​​​​​​</div>

        <div class="cart-list--item--col col-flex">
            <button class="btn-remove-product" @click="removeProduct">
                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 6H16L15.219 16.1534C15.1388 17.1954 14.2699 18 13.2249 18H6.77514C5.73007 18 4.86118 17.1954 4.78103 16.1534L4 6Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.72136 3.70066C6.85217 3.28372 7.23853 3 7.67551 3H12.3245C12.7615 3 13.1478 3.28372 13.2786 3.70066L14 6H10H6L6.72136 3.70066Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import ProductImage from '../product/ProductImage'

    export default {
        components: {
            ProductImage
        },
        emits: ['remove-product-from-cart', 'update-product-quantity'],
        props: {
            onUpdateProductQuantity: {
                type: Function
            },
            onRemoveProductFromCart: {
                type: Function
            },
            product: {
                type: Object
            },
            cartProduct:  {
                type: Object
            }
        },
        data() {
            return {
                quantity: this.cartProduct.product_quantity
            }
        },
        computed: {
            data() {
                let data = {
                    product_state_flag: this.product.product_state ? this.product.product_state.flag : null,
                    product_state_title: this.product.product_state ? this.product.product_state.title : null,
                    authors: this.product.authors
                }

                if ( [2].includes( this.product.product_type_id ) ) data = {
                    product_state_flag: 'flag-red',
                    product_state_title: this.product.product_type.name,
                    authors: this.mergeAuthors( this.product )
                }

                if ( [3, 4].includes( this.product.product_type_id ) ) data = {
                    product_state_flag: 'flag-red',
                    product_state_title: this.product.product_type.name,
                    authors: this.product.bundles[0].authors
                }

                return data
            }
        },
        methods: {
            updateQuantity( operation ) {

                switch ( operation ) {

                    case '-':

                        this.quantity > 1 ? this.quantity = this.quantity - 1 : this.quantity = 1
                        typeof AnalyticScripts != "undefined" && AnalyticScripts.removeFromCartDataLayer(this.product, this.product.product_variant, 1)

                        break

                    case '+':

                        !this.cartProduct.can_be_added ? this.quantity = this.product.quantity_in_stock : this.quantity = this.quantity + 1
                        typeof AnalyticScripts != "undefined" && AnalyticScripts.addToCartDataLayer(this.product, this.product.product_variant, 'cart')
                        break

                    default:

                        break
                }
            },
            removeProduct() {
                this.$emit('removeProductFromCart', this.product.id)
                typeof AnalyticScripts != "undefined" && AnalyticScripts.removeFromCartDataLayer(this.product, this.product.product_variant, this.quantity)
            }
        },
        watch: {
            'quantity': {
                handler: function () {
                    if ( this.timer ) {
                        clearTimeout( this.timer )
                        this.timer = null
                    }

                    this.timer = setTimeout(() => {

                        this.$emit('updateProductQuantity', `product/${this.product.id}/quantity/${this.quantity}`)

                    }, 500)
                },
                deep: true
            },
            'cartProduct.product_quantity': {
                handler( newValue ) {
                    this.quantity = newValue
                },
                immediate: true
            }
        }
    }
</script>
